import type { ReactNode } from "react";

/** Passthrough — Sentry does not require a React provider for exception capture. */
export function TelemetryProvider({ children }: { children: ReactNode }) {
  return children;
}
